export * from './Card';

import Card from './Card';
export default Card;
